var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expanded-fieldset"},[_c('div',{staticClass:"trail"},[_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_c('div',{staticClass:"fields"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }